/**
 * Canonical URL map + legacy 301 targets (hub-and-spoke SEO architecture).
 * Used by App routes, sitemap generation, and internal links.
 * Build scripts mirror: scripts/seoUrlManifest.cjs (keep both in sync).
 */

export const LOGISTICS_HUB = '/logistics';
export const FLEET_SAAS_HUB = '/fleet-saas';
export const HUBS_PREFIX = '/hubs';
export const COMPARE_LOGISTICS_VS_FLEET = '/compare/logistics-vs-fleet-saas';
export const MEDICAL_DELIVERY_SERVICE = '/medical-delivery-service';

/** Managed delivery — live in these four cities only */
export const LOGISTICS_CITY_SLUGS = ['surat', 'ahmedabad', 'pune', 'mumbai'];

/** Fleet SaaS hub pages — pan-India, city-specific landing for SEO */
export const FLEET_HUB_SLUGS = ['surat', 'mumbai', 'delhi-ncr', 'bengaluru', 'indore'];

export const FLEET_FEATURE_SLUGS = [
  'pharma-salesman-tracking-app',
  'pharma-field-attendance-tada',
  'pharma-collections-management',
  'zeromds-accounting-sync',
];

export function logisticsCityPath(slug) {
  return `${LOGISTICS_HUB}/${slug}`;
}

export function fleetHubPath(slug) {
  return `${HUBS_PREFIX}/pharma-fleet-management-${slug}`;
}

export function fleetFeaturePath(slug) {
  return `${FLEET_SAAS_HUB}/${slug}`;
}

/** Old flat URLs → canonical hub-and-spoke paths (301 / client redirect) */
export const LEGACY_REDIRECTS = {
  '/medicine-delivery-surat': logisticsCityPath('surat'),
  '/medicine-delivery-ahmedabad': logisticsCityPath('ahmedabad'),
  '/fleet-management-surat': fleetHubPath('surat'),
  '/fleet': FLEET_SAAS_HUB,
};

export const CANONICAL_SITEMAP_ENTRIES = [
  { path: '/', priority: '1.0', changefreq: 'weekly' },
  { path: LOGISTICS_HUB, priority: '0.95', changefreq: 'weekly' },
  { path: FLEET_SAAS_HUB, priority: '0.95', changefreq: 'weekly' },
  { path: MEDICAL_DELIVERY_SERVICE, priority: '0.9', changefreq: 'weekly' },
  { path: COMPARE_LOGISTICS_VS_FLEET, priority: '0.75', changefreq: 'monthly' },
  ...LOGISTICS_CITY_SLUGS.map((slug) => ({
    path: logisticsCityPath(slug),
    priority: '0.95',
    changefreq: 'weekly',
  })),
  ...FLEET_HUB_SLUGS.map((slug) => ({
    path: fleetHubPath(slug),
    priority: '0.9',
    changefreq: 'weekly',
  })),
  ...FLEET_FEATURE_SLUGS.map((slug) => ({
    path: fleetFeaturePath(slug),
    priority: '0.85',
    changefreq: 'monthly',
  })),
  { path: '/contact-us', priority: '0.95', changefreq: 'weekly' },
  { path: '/careers', priority: '0.8', changefreq: 'weekly' },
  { path: '/privacy-policy', priority: '0.4', changefreq: 'monthly' },
  { path: '/terms-condition', priority: '0.4', changefreq: 'monthly' },
  { path: '/fleet-privacy-policy', priority: '0.35', changefreq: 'monthly' },
  { path: '/distributor-privacy-policy', priority: '0.35', changefreq: 'monthly' },
  { path: '/retailers-privacy-policy', priority: '0.35', changefreq: 'monthly' },
  { path: '/rider-privacy-policy', priority: '0.35', changefreq: 'monthly' },
  { path: '/chakradhar_privacy_policy.html', priority: '0.3', changefreq: 'monthly' },
  { path: '/pavan_distributor_privacy_policy.html', priority: '0.3', changefreq: 'monthly' },
  { path: '/zeromeds_privacy_policy.html', priority: '0.3', changefreq: 'monthly' },
];

export const PLAY_STORE_LINKS = {
  fleet: 'https://play.google.com/store/apps/details?id=com.fastwhistle.fleet',
  distributor: 'https://play.google.com/store/apps/details?id=com.fastwhistle.distributor',
};
